import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h4, headingStyles } from '@helpers/typography';
import svgBullet from '@img/icons/background/bullet-wide.svg?url';
import IntroBlockStyles from '@stories/Components/Misc/IntroBlock/IntroBlock.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import SocialLinksStyles from '@stories/Components/Misc/SocialLinks/SocialLinks.styles';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
  }

  ${IntroBlockStyles.Container} {
    margin-bottom: ${fluid(32, 56)};
  }
`;
const Row = styled(m.div) `
  display: contents;
`;
const gridColumns = css `
  grid-column: 1 / -1;

  ${Row}:not(:last-of-type) & {
    margin-bottom: ${fluid(56, 104)};
  }

  @media ${from(Device.TabletSmall)} {
    grid-column: 2 / -2;
  }

  @media ${from(Device.Tablet)} {
    grid-column: 3 / -3;
  }

  @media ${from(Device.TabletLarge)} {
    &[data-align='left'] {
      grid-column: 1 / span 6;
    }

    &[data-align='right'] {
      grid-column: 7 / span 6;
    }
  }
`;
const ImageWrapper = styled(m.div) `
  ${imageWrapperPreserveRatio(768, 500)};
  ${gridColumns};

  border-radius: ${fluid(20, 48)};

  @media ${until(Device.TabletLarge)} {
    margin-bottom: 24px !important;
  }
`;
const Image = styled.img `
  ${imageCoverContainer()}
`;
const ContentWrapper = styled(m.div) `
  ${gridColumns};

  --horizontalPadding: ${fluid(32, 48)};
  --iconSize: ${fluid(56, 84)};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  @media ${from(Device.TabletLarge)} {
    grid-row: var(--row);

    &[data-align='left'] {
      padding-right: var(--horizontalPadding);
    }

    &[data-align='right'] {
      padding-left: var(--horizontalPadding);
    }
  }
`;
const ContentTop = styled.div `
  display: grid;
  gap: ${fluid(4, 16)} ${fluid(16, 24)};
  grid-template-columns: var(--iconSize) 1fr;
`;
const StepTitle = styled.h3 `
  ${h4};

  display: flex;
  gap: var(--titleGap);
  align-items: flex-start;
  margin: 0;
  width: 100%;

  @media ${from(Device.Tablet)} {
    align-items: center;
  }
`;
const StepNumber = styled.span `
  ${headingStyles};

  display: grid;
  place-content: center;
  width: var(--iconSize);
  aspect-ratio: 1;
  -webkit-mask-image: url(${svgBullet});
  mask-image: url(${svgBullet});
  mask-repeat: no-repeat;
  background-image: linear-gradient(90deg, #9f4a92 0%, #3271a9 100%);
  color: ${brand.primary.white};
  font-size: ${fluid(32, 50)};
  margin: 0;

  @media ${until(Device.Tablet)} {
    grid-row: span 2;
  }

  span {
    transform: translateY(-5%);
  }
`;
const Content = styled.div `
  ${contentStyles};

  @media ${from(Device.Tablet)} {
    ${ContentTop} & {
      grid-column: span 2;
    }
  }
`;
const SubItemWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: ${fluid(24, 40)};

  &[data-cta] {
    gap: ${fluid(12, 24)};
  }

  &[data-social] {
    gap: ${fluid(24, 32)} ${fluid(32, 64)};
    flex-wrap: wrap;

    ${SocialLinksStyles.Container} {
      --buttonSize: ${fluid(24, 32)};
      --itemSize: ${fluid(24, 32)};
    }

    @media ${from(Device.TabletLarge)} {
      flex-direction: row;
    }
  }
`;
const SocialTitle = styled.h4 `
  ${fonts.poppins.extraBold};

  font-size: ${fluid(17, 24)};
  line-height: ${fluid(25, 32)};
  margin: 0 0 8px;
  white-space: nowrap;
`;
const NextStepsStyles = {
    Container,
    Content,
    ContentTop,
    ContentWrapper,
    Image,
    ImageWrapper,
    Row,
    SocialTitle,
    StepNumber,
    StepTitle,
    SubItemWrapper,
};
export default NextStepsStyles;
